import VisualChoiceCards from './VisualChoiceCards';

const METER_OPTIONS = [
  {
    value: 'smart_p1',
    label: 'Slimme meter met P1-poort',
    hint: 'Moderne meter met aparte P1-aansluiting.',
    illustration: 'meter_p1',
  },
  {
    value: 'smart_p1_unclear',
    label: 'Slimme meter, maar P1 onbekend',
    hint: 'U weet niet zeker of er een P1-poort op zit.',
    illustration: 'meter_p1_unclear',
  },
  {
    value: 'old_unclear', // keep stable key for backward compat with existing leads
    label: 'Oude meter / analoge meter',
    hint: 'Geen moderne slimme meter.',
    illustration: 'meter_old_analog',
  },
  { value: 'unknown', label: 'Weet ik niet', hint: 'Geen probleem, we houden het simpel.', illustration: 'unknown' },
];

const PHASE_OPTIONS = [
  {
    value: 'one_phase',
    label: '1-fase aansluiting',
    hint: 'Vaak eenvoudiger meterkast of kleinere aansluiting.',
    illustration: 'cabinet_1fase',
  },
  {
    value: 'three_phase',
    label: '3-fase aansluiting',
    hint: 'Vaak zwaardere aansluiting voor grotere verbruikers.',
    illustration: 'cabinet_3fase',
  },
  { value: 'unknown', label: 'Weet ik niet', hint: 'Geen probleem, we houden het simpel.', illustration: 'unknown' },
];

const LIVE_INSIGHT_OPTIONS = [
  {
    value: 'has_dashboard',
    label: 'Ik heb al live inzicht',
    hint: 'Bijvoorbeeld via P1-uitlezing of energiedashboard.',
    illustration: 'live_dashboard',
  },
  {
    value: 'no_dashboard',
    label: 'Nog geen live inzicht',
    hint: 'Ik zie mijn verbruik nog niet live.',
    illustration: 'no_live_dashboard',
  },
  { value: 'unknown', label: 'Weet ik niet', hint: 'Geen probleem, we houden het simpel.', illustration: 'unknown' },
];

export default function StarterKitCompatibilityStep({ data, onUpdate, errors }) {
  return (
    <div className="space-y-8" data-testid="ec-sk-compat">
      <div>
        <h2 className="text-2xl font-medium text-primary mb-1.5" style={{ fontFamily: 'Outfit' }}>
          Controleer in 1 minuut welk startpakket past
        </h2>
        <p className="text-[15px] text-foreground leading-relaxed" data-testid="ec-sk-intro-instruction">
          Kies de foto die het meest op uw situatie lijkt. Twijfelt u? Kies gewoon
          <span className="font-semibold"> "Weet ik niet"</span>.
        </p>
      </div>

      <VisualChoiceCards
        label="1. Wat past het meest bij uw meter?"
        value={data.meter_type}
        options={METER_OPTIONS}
        onChange={(v) => onUpdate({ meter_type: v })}
        testIdPrefix="ec-sk-meter"
        error={errors?.meter_type}
        columns={2}
      />
      <p className="text-xs text-muted-foreground -mt-4 leading-relaxed" data-testid="ec-sk-hint-p1">
        <span className="font-medium text-foreground">P1-poort</span> = kleine aansluiting op of naast de slimme
        meter voor live verbruiksuitlezing.
      </p>

      <VisualChoiceCards
        label="2. Hoe ziet uw aansluiting eruit?"
        value={data.phase_type}
        options={PHASE_OPTIONS}
        onChange={(v) => onUpdate({ phase_type: v })}
        testIdPrefix="ec-sk-phase"
        error={errors?.phase_type}
      />
      <p className="text-xs text-muted-foreground -mt-4 leading-relaxed" data-testid="ec-sk-hint-phase">
        <span className="font-medium text-foreground">1-fase of 3-fase</span> hoeft u niet exact te weten — kies
        wat het meest lijkt.
      </p>

      <VisualChoiceCards
        label="3. Heeft u al live inzicht in uw verbruik?"
        value={data.live_insight}
        options={LIVE_INSIGHT_OPTIONS}
        onChange={(v) => onUpdate({ live_insight: v })}
        testIdPrefix="ec-sk-live-insight"
        error={errors?.live_insight}
      />

      <div className="text-xs text-muted-foreground bg-muted/40 border border-border rounded-md px-3 py-2 leading-relaxed">
        We diagnosticeren niets technisch — deze keuze helpt ons inschatten welk startpakket waarschijnlijk
        compatibel is. Een installateur of advies-stap volgt indien nodig.
      </div>
    </div>
  );
}
